(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbts-team-ordering"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bbts-team-order')) {
    class BBTSTeamOrder extends HTMLElement {
      static quantity(value) {
        const text = String(value ?? '').trim();
        if (!text) return 0;
        if (!/^\d+$/.test(text)) throw new Error('invalidQuantity');
        const quantity = Number(text);
        if (!Number.isSafeInteger(quantity) || quantity > 9999) throw new Error('invalidQuantity');
        return quantity;
      }
      static selection(variants, values) {
        const result = { items: [], quantity: 0, subtotal: 0 };
        const byId = new Map(variants.map(variant => [String(variant.id), variant]));
        for (const [id, raw] of values) {
          const quantity = this.quantity(raw);
          if (!quantity) continue;
          const variant = byId.get(String(id));
          if (!variant || !variant.available) throw new Error('unavailableError');
          const rule = variant.quantity_rule || {};
          const minimum = Math.max(1, Number(rule.min) || 1);
          const increment = Math.max(1, Number(rule.increment) || 1);
          if (quantity < minimum || quantity % increment !== 0 || (rule.max != null && quantity > Number(rule.max))) throw new Error('quantityRule');
          if (!Number.isSafeInteger(variant.price) || variant.price < 0) throw new Error('initFailed');
          result.items.push({ id: String(variant.id), quantity, variant });
          result.quantity += quantity;
          result.subtotal += variant.price * quantity;
        }
        return result;
      }
      static eligibleTiers(config) {
        if (!config.pricingVerified || config.currency !== config.pricingCurrency) return [];
        return (config.tiers || []).filter(tier => {
          const matchingProduct = String(tier.productId) === String(config.productId);
          const matchingAutomatic = config.automaticPricing === true && config.bulkEligible === true && (!tier.productId || matchingProduct);
          const matchingCode = !config.automaticPricing && matchingProduct && typeof tier.code === 'string' && tier.code.trim();
          return (matchingAutomatic || matchingCode) && Number.isInteger(tier.minimum) && tier.minimum >= 2 && Number.isFinite(tier.percent) && tier.percent > 0 && tier.percent <= 30;
        }).sort((a, b) => a.minimum - b.minimum);
      }
      static selectedTier(tiers, quantity) {
        return tiers.filter(tier => quantity >= tier.minimum).sort((a, b) => b.percent - a.percent || b.minimum - a.minimum)[0] || null;
      }
      static presentation(config, variants) {
        const options = config.options || [];
        const preferredName = (config.sizeOption || 'Size').trim().toLowerCase();
        let rowIndex = options.findIndex(name => name.trim().toLowerCase() === preferredName);
        if (rowIndex < 0) rowIndex = options.findIndex(name => /^(size|sizes)$/i.test(name.trim()));
        if (rowIndex < 0) rowIndex = Math.max(0, options.length - 1);
        const details = options.map((name, index) => {
          const values = Array.from(new Set(variants.map(variant => variant.options[index]).filter(value => value != null)));
          let kind = 'options';
          if (/^(colou?r|colou?rs)$/i.test(name.trim())) kind = 'colours';
          else if (/pack|weight|volume/i.test(name) || values.length && values.every(value => /^\d+(?:\.\d+)?\s*(kg|g|ml|l|litres?|liters?)$/i.test(String(value).trim()))) kind = 'packs';
          else if (/width/i.test(name) || values.length && values.every(value => /^\d+(?:\.\d+)?\s*(mm|cm)$/i.test(String(value).trim()))) kind = 'widths';
          else if (/^(size|sizes)$/i.test(name.trim())) kind = 'sizes';
          return { name, index, values, kind };
        });
        const varying = details.filter(option => option.values.length > 1);
        const kinds = new Set(varying.map(option => option.kind));
        const kind = !varying.length ? 'quantity' : varying.length === 1 ? varying[0].kind : varying.length === 2 && kinds.has('sizes') && kinds.has('colours') ? 'sizes_colours' : 'options';
        const row = details[rowIndex];
        const rowKind = row?.values.length > 1 ? row.kind : 'quantity';
        const type = String(config.productType || '').toLowerCase();
        let heading = 'heading_generic';
        if (/headwear|\bhats?\b|\bcaps?\b/.test(type)) heading = 'heading_headwear';
        else if (/apron/.test(type)) heading = 'heading_aprons';
        else if (/scrubs/.test(type)) heading = 'heading_scrubs';
        else if (/footwear|boots|shoes/.test(type)) heading = 'heading_footwear';
        else if (/workwear|uniform|polos|shirts|tees|singlets|jumpers|jackets|vests|shorts|trousers|corporate wear|painters wear/.test(type)) heading = 'heading_uniforms';
        else if (/rags|consumables|cleaning supplies/.test(type)) heading = 'heading_supplies';
        else if (/tools|paint accessories/.test(type)) heading = 'heading_tools';
        return { heading, intro: 'intro_' + kind, badge: 'badge_' + kind, gridHint: 'grid_' + rowKind, rowIndex, rowLabel: row?.name === 'Title' || !row ? 'label_item' : ['packs', 'widths', 'colours'].includes(row.kind) ? 'label_' + row.kind : null, hasFilters: varying.some(option => option.index !== rowIndex) };
      }
      static cartQuantities(cart) {
        const quantities = new Map();
        for (const item of cart.items || []) {
          const id = String(item.variant_id || item.id);
          quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
        }
        return quantities;
      }
      static addedAsRequested(before, after, items) {
        const previous = this.cartQuantities(before);
        const current = this.cartQuantities(after);
        return items.every(item => (current.get(String(item.id)) || 0) - (previous.get(String(item.id)) || 0) >= item.quantity);
      }
      connectedCallback() {
        if (this.initialised) { this.setCalloutVisibility(!this.hidden && Boolean(this.tiers?.length)); return; }
        this.initialised = true;
        try {
          this.config = JSON.parse(this.querySelector('[data-team-config]').textContent);
          this.strings = this.config.strings;
          this.values = new Map();
          this.busy = false;
          this.uncertain = false;
          this.storageKey = 'bbts-team-selection-v1-' + this.config.productId;
          this.moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: this.config.currency });
          this.variants = (this.config.variants || []).map((variant, index) => ({ ...variant, options: variant.options || [variant.option1, variant.option2, variant.option3].filter(value => value != null), quantity_rule: this.config.quantityRules[index] || variant.quantity_rule || {} }));
          this.tiers = BBTSTeamOrder.eligibleTiers(this.config);
          if (!this.tiers.length) { this.hidden = true; this.setCalloutVisibility(false); return; }
          this.view = BBTSTeamOrder.presentation(this.config, this.variants);
          this.sizeIndex = this.view.rowIndex;
          this.renderCopy();
          this.renderTiers();
          this.setupQuote();
          this.setCalloutVisibility(true);
          if (!this.config.supported) return;
          this.filters = new Map();
          this.restore();
          this.renderFilters();
          this.renderRows();
          this.querySelector('[data-clear]').addEventListener('click', () => { this.values.clear(); this.persist(); this.renderRows(); this.update(); });
          this.querySelector('[data-add]').addEventListener('click', () => this.addSelection());
          this.querySelector('[data-open-quote]').addEventListener('click', () => this.openQuote());
          this.querySelector('[data-interactive]').hidden = false;
          this.update();
        } catch {
          this.setCalloutVisibility(false);
          const notice = this.querySelector('[data-init-error]');
          if (notice) notice.hidden = false;
          const interactive = this.querySelector('[data-interactive]');
          if (interactive) interactive.hidden = true;
          const panel = this.querySelector('[data-quote-panel]');
          if (panel) panel.open = true;
          const status = this.querySelector('[data-status]');
          if (status) { status.textContent = this.strings?.initFailed || ''; status.dataset.error = 'true'; }
        }
      }
      disconnectedCallback() { this.setCalloutVisibility(false); }
      setCalloutVisibility(visible) {
        if (!this.config) return;
        if (!this.calloutClick) this.calloutClick = () => this.syncProductFilters();
        for (const link of document.querySelectorAll('.bbts-team-callout[data-bbts-product-id]')) {
          if (link.dataset.bbtsProductId !== String(this.config.productId)) continue;
          link.hidden = !visible;
          link.removeEventListener('click', this.calloutClick);
          if (visible) link.addEventListener('click', this.calloutClick);
          if (visible && this.view) link.querySelector('strong').textContent = this.config.presentation[this.view.heading];
        }
      }
      syncProductFilters() {
        if (!this.filters || !this.config.supported || this.busy) return;
        const id = new URL(window.location.href).searchParams.get('variant') || this.config.selectedVariantId;
        const variant = this.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        for (const [index] of this.filters) {
          this.filters.set(index, variant.options[index]);
          const select = this.querySelector('#BBTSTeamOption-' + this.config.sectionId + '-' + index);
          if (select) select.value = variant.options[index];
        }
        this.renderRows();
        this.update();
      }
      renderCopy() {
        const copy = this.config.presentation;
        for (const [selector, key] of [['[data-team-heading]', this.view.heading], ['[data-team-intro]', this.view.intro], ['[data-team-badge]', this.view.badge], ['[data-grid-help]', this.view.gridHint]]) {
          const element = this.querySelector(selector);
          if (element) element.textContent = copy[key];
        }
        const hint = this.querySelector('[data-grid-help]');
        if (hint && this.view.hasFilters) hint.textContent += ' ' + copy.switch_options;
      }
      text(key, values = {}) {
        let text = this.strings[key] || '';
        for (const [name, value] of Object.entries(values)) text = text.split('[' + name + ']').join(String(value));
        return text;
      }
      money(cents) { return this.moneyFormatter.format(cents / 100); }
      variantLabel(variant) { return variant.title === 'Default Title' ? this.config.productTitle : variant.title; }
      restore() {
        try {
          const stored = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
          if (stored?.created && Date.now() - stored.created < 7200000 && Array.isArray(stored.values)) {
            const ids = new Set(this.variants.map(variant => String(variant.id)));
            this.values = new Map(stored.values.filter(pair => Array.isArray(pair) && ids.has(String(pair[0]))).map(([id, value]) => [String(id), String(value)]));
          }
        } catch { this.values = new Map(); }
      }
      persist() {
        try { sessionStorage.setItem(this.storageKey, JSON.stringify({ created: Date.now(), values: Array.from(this.values) })); } catch {}
      }
      renderFilters() {
        const container = this.querySelector('[data-filters]');
        const selected = this.variants.find(variant => String(variant.id) === String(this.config.selectedVariantId));
        this.config.options.forEach((name, index) => {
          if (index === this.sizeIndex) return;
          const values = Array.from(new Set(this.variants.map(variant => variant.options[index])));
          const selectedValue = selected?.options[index] ?? values[0];
          this.filters.set(index, selectedValue);
          if (values.length < 2) return;
          const wrapper = document.createElement('div');
          const label = document.createElement('label');
          const select = document.createElement('select');
          select.id = 'BBTSTeamOption-' + this.config.sectionId + '-' + index;
          label.htmlFor = select.id;
          label.textContent = name;
          for (const value of values) { const option = document.createElement('option'); option.value = value; option.textContent = value; select.append(option); }
          select.value = selectedValue;
          select.addEventListener('change', () => { this.filters.set(index, select.value); this.renderRows(); this.update(); });
          wrapper.append(label, select); container.append(wrapper);
        });
        this.querySelector('[data-size-label]').textContent = this.view.rowLabel ? this.config.presentation[this.view.rowLabel] : this.config.options[this.sizeIndex] || this.text('variant');
      }
      renderRows() {
        const body = this.querySelector('[data-rows]');
        body.replaceChildren();
        const visible = this.variants.filter(variant => Array.from(this.filters).every(([index, value]) => variant.options[index] === value));
        if (!visible.length) {
          const row = document.createElement('tr'); const message = document.createElement('td');
          message.colSpan = 4; message.textContent = this.text('noCombination'); row.append(message); body.append(row);
        }
        for (const variant of visible) {
          const row = document.createElement('tr');
          row.dataset.variantId = String(variant.id);
          row.dataset.unavailable = String(!variant.available);
          const size = document.createElement('td');
          const name = document.createElement('strong');
          name.textContent = variant.title === 'Default Title' ? this.config.productTitle : variant.options[this.sizeIndex] || variant.title;
          const mobilePrice = document.createElement('span');
          mobilePrice.className = 'bbts-team__mobile-price'; mobilePrice.textContent = this.money(variant.price);
          size.append(name, mobilePrice);
          if (!variant.available) { const notice = document.createElement('span'); notice.className = 'bbts-team__unavailable'; notice.textContent = this.text('unavailable'); size.append(notice); }
          const price = document.createElement('td'); price.className = 'bbts-team__unit'; price.textContent = this.money(variant.price);
          const quantity = document.createElement('td');
          const input = document.createElement('input');
          input.type = 'number'; input.min = '0'; input.max = String(Math.min(9999, variant.quantity_rule?.max ?? 9999)); input.step = '1'; input.inputMode = 'numeric';
          input.className = 'bbts-team__qty'; input.dataset.quantityId = String(variant.id); input.value = this.values.get(String(variant.id)) || '0'; input.disabled = !variant.available;
          input.setAttribute('aria-label', this.text('quantityFor', { variant: this.variantLabel(variant) }));
          input.setAttribute('aria-describedby', 'BBTSTeamGridHelp-' + this.config.sectionId);
          input.addEventListener('input', () => { this.values.set(String(variant.id), input.value); this.persist(); this.update(); });
          input.addEventListener('focus', () => input.select());
          quantity.append(input);
          const total = document.createElement('td'); total.className = 'bbts-team__right'; total.dataset.lineTotal = ''; total.textContent = this.money(0);
          row.append(size, price, quantity, total); body.append(row);
        }
      }
      renderTiers() {
        const box = this.querySelector('[data-pricing]');
        if (!this.tiers.length) return;
        box.hidden = false;
        for (const tier of this.tiers) {
          const label = Array.from(this.querySelectorAll('[data-tier-block-id]')).find(item => item.dataset.tierBlockId === tier.blockId);
          if (!label) continue;
          label.hidden = false; label.dataset.minimum = tier.minimum; label.dataset.percent = tier.percent;
          const quantity = document.createElement('span');
          quantity.className = 'bbts-team__tier-quantity';
          quantity.textContent = this.text('tierQuantity', { minimum: tier.minimum });
          const saving = document.createElement('strong');
          saving.className = 'bbts-team__tier-saving';
          saving.textContent = this.text('tierSaving', { percent: tier.percent });
          label.replaceChildren(quantity, saving);
        }
      }
      getSelection() { return BBTSTeamOrder.selection(this.variants, this.values); }
      update() {
        let selection;
        let error;
        try { selection = this.getSelection(); } catch (problem) { error = problem.message; selection = { items: [], quantity: 0, subtotal: 0 }; }
        for (const input of this.querySelectorAll('[data-quantity-id]')) {
          const row = input.closest('tr'); const variant = this.variants.find(item => String(item.id) === input.dataset.quantityId);
          try {
            const single = BBTSTeamOrder.selection([variant], new Map([[String(variant.id), input.value]]));
            input.setAttribute('aria-invalid', 'false'); input.setCustomValidity(''); row.dataset.selected = String(single.quantity > 0); row.querySelector('[data-line-total]').textContent = this.money(single.subtotal);
          } catch (problem) { input.setAttribute('aria-invalid', 'true'); input.setCustomValidity(this.text(problem.message)); row.querySelector('[data-line-total]').textContent = '—'; }
        }
        this.querySelector('[data-count]').textContent = error ? this.text(error) : selection.quantity ? this.text(selection.quantity === 1 ? 'itemSelected' : 'itemsSelected', { quantity: selection.quantity }) : this.text('noneSelected');
        this.querySelector('[data-subtotal]').textContent = error ? '—' : this.money(selection.subtotal);
        this.querySelector('[data-selection-hint]').textContent = selection.items.length ? this.text(selection.items.length === 1 ? 'selectedVariant' : 'selectedVariants', { count: selection.items.length }) : this.text('selectionHint');
        const add = this.querySelector('[data-add]'); add.disabled = this.busy || this.uncertain || !selection.quantity || Boolean(error);
        this.querySelector('[data-clear]').disabled = this.busy || (!error && !selection.quantity);
        this.querySelector('[data-selection-panel]').hidden = !selection.items.length;
        const list = this.querySelector('[data-selection-list]'); list.replaceChildren();
        for (const item of selection.items) { const line = document.createElement('li'); line.textContent = this.variantLabel(item.variant) + ' × ' + item.quantity + ' — ' + this.money(item.variant.price * item.quantity); list.append(line); }
        const tier = BBTSTeamOrder.selectedTier(this.tiers, selection.quantity);
        for (const item of this.querySelectorAll('[data-minimum]')) item.dataset.active = String(Boolean(tier && Number(item.dataset.minimum) === tier.minimum && Number(item.dataset.percent) === tier.percent));
        const nextTier = this.tiers.find(item => item.minimum > selection.quantity);
        const offer = this.querySelector('[data-offer]');
        offer.hidden = !selection.quantity || Boolean(error);
        offer.textContent = tier ? this.text(this.config.automaticPricing ? 'automaticOffer' : 'offer', { percent: tier.percent, code: tier.code }) : nextTier ? this.text('nextTier', { remaining: nextTier.minimum - selection.quantity, percent: nextTier.percent }) : '';
        this.updateQuote(selection, error);
      }
      quoteText(selection) {
        if (!selection.items.length) return '';
        const lines = [this.config.productTitle];
        for (const item of selection.items) lines.push(this.variantLabel(item.variant) + (item.variant.sku ? ' | SKU ' + item.variant.sku : '') + ' | ' + item.quantity + ' × ' + this.money(item.variant.price) + ' = ' + this.money(item.quantity * item.variant.price));
        lines.push(this.text('subtotal') + ': ' + this.money(selection.subtotal) + ' ' + this.config.currency, this.text('quotePriceNote'));
        return lines.join('\n');
      }
      updateQuote(selection, error) {
        const hidden = this.querySelector('[data-quote-selection]');
        if (!hidden) return;
        const summary = error ? '' : this.quoteText(selection);
        hidden.value = summary;
        this.querySelector('[data-quote-preview]').textContent = summary;
        this.querySelector('[data-quote-summary]').hidden = !summary;
        this.querySelector('[data-quote-notes]').required = !selection.quantity;
        this.querySelector('[data-quote-notes-label]').textContent = this.text(selection.quantity ? 'notesOptionalLabel' : 'notesRequiredLabel');
      }
      setupQuote() {
        const panel = this.querySelector('[data-quote-panel]');
        const success = this.querySelector('[data-form-success]');
        if (success || this.querySelector('[data-form-errors]')) { panel.open = true; if (success) { try { sessionStorage.removeItem(this.storageKey); } catch {} } }
        const form = this.querySelector('.bbts-team__quote-form');
        const notes = this.querySelector('[data-quote-notes]');
        if (!notes) return;
        notes.required = true;
        notes.addEventListener('input', () => notes.setCustomValidity(''));
        form.addEventListener('submit', event => {
          let selection = { items: [], quantity: 0, subtotal: 0 };
          try { if (this.config.supported) selection = this.getSelection(); }
          catch (problem) { event.preventDefault(); this.setStatus(this.text(problem.message), true); return; }
          if (!selection.quantity && !notes.value.trim()) { event.preventDefault(); notes.setCustomValidity(this.text('notesRequired')); notes.reportValidity(); return; }
          this.updateQuote(selection);
        });
      }
      openQuote() {
        const panel = this.querySelector('[data-quote-panel]'); panel.open = true;
        panel.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        const input = panel.querySelector('input:not([type=hidden])'); if (input) input.focus({ preventScroll: true });
      }
      setStatus(message, error = false) { const status = this.querySelector('[data-status]'); status.textContent = message; status.dataset.error = String(error); }
      async readCart() {
        const response = await fetch(this.config.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('readFailed');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('readFailed');
        return cart;
      }
      async addSelection() {
        if (this.busy || this.uncertain) return;
        let selection;
        try { selection = this.getSelection(); if (!selection.quantity) throw new Error('selectQuantity'); }
        catch (problem) { this.setStatus(this.text(problem.message), true); return; }
        this.busy = true; this.update(); this.setStatus(this.text('adding'));
        const add = this.querySelector('[data-add]'); add.textContent = this.text('adding');
        this.setAttribute('aria-busy', 'true');
        for (const input of this.querySelectorAll('[data-quantity-id], [data-filters] select, [data-clear]')) input.disabled = true;
        let submitted = false;
        try {
          const before = await this.readCart();
          const root = this.config.root.replace(/\/?$/, '/');
          submitted = true;
          const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: selection.items.map(item => ({ id: item.id, quantity: item.quantity })) }) });
          let result;
          try { result = await response.json(); } catch { throw new Error('uncertain'); }
          if (!response.ok || result.status >= 400) throw new Error('cartChanged');
          const after = await this.readCart();
          if (!BBTSTeamOrder.addedAsRequested(before, after, selection.items)) throw new Error('cartChanged');
          const tier = BBTSTeamOrder.selectedTier(this.tiers, selection.quantity);
          this.values.clear(); this.persist(); this.renderRows(); this.update(); this.setStatus(this.text('added'));
          this.querySelector('[data-cart-link]').hidden = false;
          this.uncertain = true;
          const destination = tier && !this.config.automaticPricing ? root + 'discount/' + encodeURIComponent(tier.code) + '?redirect=' + encodeURIComponent(this.config.cartUrl) : this.config.cartUrl;
          window.location.assign(destination);
        } catch (problem) {
          this.uncertain = submitted;
          this.setStatus(this.text(submitted ? problem.message === 'cartChanged' ? 'cartChanged' : 'uncertain' : 'readFailed'), true);
          this.querySelector('[data-cart-link]').hidden = !submitted;
        } finally {
          this.busy = false; this.removeAttribute('aria-busy'); add.textContent = this.text('add');
          for (const input of this.querySelectorAll('[data-quantity-id], [data-filters] select, [data-clear]')) input.disabled = input.matches('[data-quantity-id]') && !this.variants.find(item => String(item.id) === input.dataset.quantityId)?.available;
          this.update();
        }
      }
    }
    customElements.define('bbts-team-order', BBTSTeamOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
